import { Navigate } from 'react-router';
import type { ReactNode } from 'react';
import { useTutorProfile } from '@/lib/tutor-profile-context';

/**
 * Blocks the onboarding/edit-profile flow while the tutor's profile is under
 * admin review. A profile in `pending_review` is locked — the tutor must wait
 * for the outcome before making further changes. Redirects home, where the
 * dashboard shows the "under review" status banner.
 *
 * No profile yet (first onboarding) passes through, as does any other status.
 */
export function RequireEditableTutorProfile({ children }: { children: ReactNode }) {
  const tutorCtx = useTutorProfile();

  if (!tutorCtx || tutorCtx.loading) return null;

  if (tutorCtx.profile?.publishStatus === 'pending_review') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
